// extracted by mini-css-extract-plugin
export default {"root":"_18rKH","icon":"_3i9j-"};